import React from 'react';

import s from './Disclaimer.css';


const Disclaimer = () =>
    <div
        id="disclaimer"
        className={s.component}
    >
        <h3 className={s.emphasis}>
            This is the beginning of your conversation history.
        </h3>
        <br />
        <p className={s.text}>
            Please note - Secure Texting is not suitable to use in the case of medical emergencies. <strong>If you are experiencing a medical emergency, please dial 9-1-1.</strong>
        </p>
    </div>;

export default Disclaimer;
